.parent-load-container{padding:1rem 2rem}.child-load-container{padding:0 2rem}::ng-deep .cancel-button,::ng-deep .right-button{width:200px!important}
/*# sourceMappingURL=smart-bag-check-component.component-QB4GW2LO.css.map */
